import { useMutation } from "@tanstack/react-query"
import { inactivateUser } from "../../../api/users/inactivateUser"

export const useInactivateUser = () => {

  return useMutation({
    mutationKey: ["inactivateUser"],
    mutationFn: inactivateUser
  })
}